module.exports = __webpack_public_path__ + "static/img/icon09.a404b219.png";